import React from 'react';

import { Separator as SeparatorPrimitive } from '@base-ui-components/react/separator';

import { cn } from 'shared/lib/utils';

function Separator({
  className,
  orientation = 'horizontal',
  ...props
}: SeparatorPrimitive.Props) {
  return (
    <SeparatorPrimitive
      data-slot="separator"
      orientation={orientation}
      className={cn(
        'shrink-0 bg-body-copy-gray/24',
        orientation === 'horizontal' ? 'h-px w-full' : 'w-px self-stretch',
        className
      )}
      {...props}
    />
  );
}

export { Separator };
